/* Avichome product page extras: delivery ETA + sticky add-to-cart */
(function () {
  function addBusinessDays(d, n) { var r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; } return r; }
  function fmtDate(d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
  function eta() {
    document.querySelectorAll('[data-avi-eta]').forEach(function (el) {
      var now = new Date(), a = addBusinessDays(now, Number(el.dataset.min)), b = addBusinessDays(now, Number(el.dataset.max));
      var t = el.querySelector('[data-eta-text]'); if (t) t.textContent = fmtDate(a) + ' – ' + fmtDate(b);
    });
  }
  function sticky() {
    var bar = document.querySelector('[data-avi-sticky]'); if (!bar) return;
    var sid = bar.dataset.section;
    var mainBtn = document.getElementById('ProductSubmitButton-' + sid);
    if (!mainBtn) return;
    document.body.appendChild(bar);
    var btn = bar.querySelector('[data-sticky-add]');
    function update() {
      var sub = '', now = '', was = '';
      var qb = document.querySelector('.avi-qb[data-section="' + sid + '"]');
      var act = qb && qb.querySelector('.avi-qb__tier.is-active');
      if (act) {
        var name = act.querySelector('[data-tier-name]'); var r = act.querySelector('input[type=radio]');
        sub = (name ? name.textContent.trim() : '') + (r ? ' · ' + r.dataset.qty + (r.dataset.qty === '1' ? ' item' : ' items') : '');
        var n = act.querySelector('.avi-qb__price [data-now], .avi-qb__info [data-now]'); var w = act.querySelector('[data-was]');
        now = n ? n.textContent.split('·')[0].trim() : ''; was = w ? w.textContent.trim() : '';
      }
      if (!now) {
        var p = document.getElementById('price-' + sid);
        var sale = p && p.querySelector('.price__sale .price-item--sale'), reg = p && p.querySelector('.price__regular .price-item--regular');
        var onSale = p && p.querySelector('.price--on-sale');
        now = onSale && sale ? sale.textContent.trim() : (reg ? reg.textContent.trim() : '');
        var cmp = p && p.querySelector('.price__sale s .price-item--regular, .price__sale .price-item--regular');
        was = onSale && cmp ? cmp.textContent.trim() : '';
      }
      var varSel = document.querySelector('#variant-selects-' + sid + ' input:checked, #variant-selects-' + sid + ' select');
      if (!sub && varSel) sub = varSel.value;
      bar.querySelector('[data-sticky-sub]').textContent = sub;
      bar.querySelector('[data-sticky-now]').textContent = now;
      bar.querySelector('[data-sticky-was]').textContent = was;
      var disabled = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
      btn.disabled = mainBtn.disabled;
      btn.textContent = mainBtn.disabled ? (mainBtn.textContent.trim() || 'Sold out') : 'Add to cart';
    }
    var shown = false;
    function setShown(v) { if (v === shown) return; shown = v; bar.classList.toggle('is-visible', v); bar.setAttribute('aria-hidden', v ? 'false' : 'true'); btn.tabIndex = v ? 0 : -1; document.body.classList.toggle('avi-has-sticky', v); if (v) update(); }
    new IntersectionObserver(function (entries) {
      var e = entries[0]; setShown(!e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(mainBtn);
    document.addEventListener('change', function () { if (shown) setTimeout(update, 30); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(update, 60); });
    btn.addEventListener('click', function () { mainBtn.click(); });
    update();
  }
  function init() { eta(); sticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
